import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import MethodologyAnchor from '../../shared/methodologyAnchor/MethodologyAnchor';
import { StyledRecharts } from '../../shared/recharts/Recharts.styled';
import { MOSTUSEDTECHSBYLANGUAGE } from '../Talent.constants';

const MostUsedTechsByLanguage: React.FC = () => {
  return (
    <div>
      <StyledRecharts>
        <ResponsiveContainer height={400} width="99%" minWidth={500}>
          <BarChart data={MOSTUSEDTECHSBYLANGUAGE} layout="vertical">
            <XAxis
              type="number"
              allowDecimals={false}
              tickLine={false}
              padding={{ left: 20 }}
              tickFormatter={(tick) => {
                return `${tick}%`;
              }}
            ></XAxis>
            <YAxis
              type="category"
              dataKey="language"
              tickLine={false}
              width={120}
            />
            <Tooltip
              cursor={{ fill: '#ebe8df' }}
              labelStyle={{ display: 'none' }}
              separator=""
              formatter={(value: number) => [value.toFixed(1) + '%', '']}
              wrapperClassName="tooltip-y"
            />
            <Bar dataKey="value" fill="fill" barSize={12} radius={5} />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
      <MethodologyAnchor />
    </div>
  );
};

export default MostUsedTechsByLanguage;
